import { Column, Form, Row } from "@cea/ui-kit";
import PropTypes from "prop-types";

import UnifiedUpload from "../../../../components/UnifiedUpload";

export const summaryServiceLines = [
  { label: "Container Loading", value: "containerLoading" },
  { label: "Lab Testing", value: "labTesting" },
  { label: "PSR", value: "psr" },
  { label: "Other Project Files", value: "otherProjectFiles" },
];

const ReportUploadForm = ({ formInstance, shouldAllowZip }) => (
  <Form form={formInstance} layout="vertical" requiredMark={true}>
    <Row gutter={45}>
      <Column span={24}>
        <Form.Item
          name="link"
          label="Upload File"
          rules={[{ required: true, message: "File is required" }]}
        >
          <UnifiedUpload shouldAllowZip={shouldAllowZip} />
        </Form.Item>
      </Column>
    </Row>
  </Form>
);

ReportUploadForm.defaultProps = {
  formInstance: null,
  summaryReport: false,
  clientReport: false,
  shouldAllowZip: false,
};

ReportUploadForm.propTypes = {
  formInstance: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    setFieldValue: PropTypes.func,
    getFieldsValue: PropTypes.func,
    resetFields: PropTypes.func,
  }),
  summaryReport: PropTypes.bool,
  clientReport: PropTypes.bool,
  shouldAllowZip: PropTypes.bool,
};

export default ReportUploadForm;
